var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2068_81356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.37505 17.425C6.35005 17.425 6.31672 17.4417 6.29172 17.4417C4.67505 16.6417 3.35838 15.3167 2.55005 13.7C2.55005 13.675 2.56672 13.6417 2.56672 13.6167C3.58338 13.9167 4.63338 14.1417 5.67505 14.3167C5.85838 15.3667 6.07505 16.4084 6.37505 17.425Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.45 13.7084C16.625 15.3667 15.25 16.7084 13.575 17.5167C13.8916 16.4584 14.1583 15.3917 14.3333 14.3167C15.3833 14.1417 16.4166 13.9167 17.4333 13.6167C17.425 13.65 17.45 13.6834 17.45 13.7084Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5166 6.42494C16.4666 6.10828 15.4083 5.84994 14.3333 5.66661C14.1583 4.59161 13.9 3.52494 13.575 2.48328C15.3 3.30828 16.6916 4.69994 17.5166 6.42494Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.37494 2.57505C6.07494 3.59172 5.85828 4.62505 5.68328 5.67505C4.60828 5.84172 3.54161 6.10838 2.48328 6.42505C3.29161 4.75005 4.63328 3.37505 6.29161 2.55005C6.31661 2.55005 6.34994 2.57505 6.37494 2.57505Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9083 5.49163C10.975 5.27496 9.02501 5.27496 7.09167 5.49163C7.30001 4.34996 7.56667 3.20829 7.94167 2.10829C7.95834 2.04163 7.95001 1.99163 7.95834 1.92496C8.61667 1.76663 9.29167 1.66663 10 1.66663C10.7 1.66663 11.3833 1.76663 12.0333 1.92496C12.0417 1.99163 12.0417 2.04163 12.0583 2.10829C12.4333 3.21663 12.7 4.34996 12.9083 5.49163Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49163 12.9083C4.34163 12.7 3.20829 12.4333 2.10829 12.0583C2.04163 12.0417 1.99163 12.05 1.92496 12.0417C1.76663 11.3833 1.66663 10.7083 1.66663 10C1.66663 9.30001 1.76663 8.61667 1.92496 7.96667C1.99163 7.95834 2.04163 7.95834 2.10829 7.94167C3.21663 7.57501 4.34163 7.30001 5.49163 7.09167C5.28329 9.02501 5.28329 10.975 5.49163 12.9083Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 10C18.3333 10.7083 18.2333 11.3833 18.075 12.0417C18.0083 12.05 17.9583 12.0417 17.8916 12.0583C16.7833 12.425 15.65 12.7 14.5083 12.9083C14.725 10.975 14.725 9.02501 14.5083 7.09167C15.65 7.30001 16.7916 7.56667 17.8916 7.94167C17.9583 7.95834 18.0083 7.96667 18.075 7.96667C18.2333 8.62501 18.3333 9.30001 18.3333 10Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9083 14.5083C12.7 15.6583 12.4333 16.7916 12.0583 17.8916C12.0417 17.9583 12.0417 18.0083 12.0333 18.075C11.3833 18.2333 10.7 18.3333 10 18.3333C9.29167 18.3333 8.61667 18.2333 7.95834 18.075C7.95001 18.0083 7.95834 17.9583 7.94167 17.8916C7.57501 16.7833 7.30001 15.6583 7.09167 14.5083C8.05834 14.6166 9.02501 14.6916 10 14.6916C10.975 14.6916 11.95 14.6166 12.9083 14.5083Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1361 13.1361C11.0518 13.399 8.9481 13.399 6.86385 13.1361C6.60088 11.0518 6.60088 8.9481 6.86385 6.86385C8.9481 6.60088 11.0518 6.60088 13.1361 6.86385C13.399 8.9481 13.399 11.0518 13.1361 13.1361Z",
    fill: "#878787"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2068_81356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.bd308a45ee201f8dac8a88c2c009106e.svg";
export { ForwardRef as ReactComponent };